module.exports = __webpack_public_path__ + "img/ic_PDF.54186e03.svg";